export default __webpack_public_path__ + "static/media/logo_ayala_disabled.00cfe6ea.png";